import React, { useState } from "react"
import Button from "../atoms/button.atom"
import Switch from "../atoms/switch.atom"
import { TrashIcon, ChatAltIcon } from "@heroicons/react/outline"
import { EndpointConfig } from "../../config"
import { axiosInstance } from "../../lib/axios"
import { toast } from "react-toastify"
import { ListHubContacts } from "../list-hub-user/list-hub-user.component"
import { Header } from "../common/header"

export const SmsHandler = ({ hubId }) => {
	const [loading, setLoading] = useState(false)
	const [toggle, setToggle] = useState(false)
	const [smsTemplates, setsmsTemplates] = useState([])
	const [wpTemplates, setwpTemplates] = useState([])

	const [selectedContacts, setSelectedContacts] = useState([])
	const [currentTemplate, setCurrentTemplate] = useState({})

	const getSMSTemplates = () => {
		return axiosInstance.get(EndpointConfig.VFSMSTemplates + "?filter=Contact", {
			headers: { "hub-id": hubId }
		})
	}

	const getWPTemplates = () => {
		return axiosInstance.get(EndpointConfig.VFWhatsAppTemplates + "?filter=Contact", {
			headers: { "hub-id": hubId }
		})
	}

	React.useEffect(() => {
		setLoading(true)
		;(async () => {
			const res = await getSMSTemplates()
			setsmsTemplates(res.data.data)

			const res2 = await getWPTemplates()
			setwpTemplates(res2.data)
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}, [])

	const sendSms = () => {
		if (!(selectedContacts && selectedContacts.length > 0)) {
			toast("Please select at least one contact")
			return
		}
		setLoading(true)
		;(async () => {
			const reqContacts = selectedContacts.map((cont) => {
				return {
					phone: cont.phone,
					hs_object_id: cont.hs_object_id
				}
			})

			const url = toggle ? EndpointConfig.VFSendWhatsApp : EndpointConfig.VFSendSMS
			const templateId = toggle ? currentTemplate.templateid : currentTemplate._id

			await axiosInstance.post(
				url,
				{
					contacts: reqContacts,
					templateId: templateId,
					populateVariable: true
				},
				{ headers: { "hub-id": hubId } }
			)
			toast("Message Sent")
			setSelectedContacts([])
			setCurrentTemplate({})
		})()
			.catch((err) => {
				console.error(err)
				if (err?.response?.data?.message) {
					toast(err.response.data.message)
				} else {
					toast("something went wrong")
				}
			})
			.finally(() => setLoading(false))
	}

	const differenceInArray = (arr1, arr2, key) => {
		return arr1.filter((item) => !arr2.find((item2) => item2[key] === item[key]))
	}

	const onContactSelect = (cont) => {
		const newSelectedContact = differenceInArray(cont, selectedContacts, "hs_object_id")

		if (newSelectedContact.length > 0) {
			setSelectedContacts([...selectedContacts, ...newSelectedContact])
		}
	}

	const removeSelectedContact = ({ hs_object_id }) => {
		setSelectedContacts(selectedContacts.filter(({ hs_object_id: id }) => id !== hs_object_id))
	}

	return (
		<>
			<div className="flex flex-col">
				<Header
					IconName={ChatAltIcon}
					subText={"Message"}
					mainText={"Send Message"}
					postComponent={
						<Switch
							label={"What'sApp"}
							toggle={toggle}
							onToggleClick={() => setToggle(!toggle)}
						/>
					}
				/>
				<div className="flex flex-row gap-4">
					<div className="flex flex-col w-3/12 p-4 bg-white border-r border-gray-200 border-solid rounded ">
						<div className="mt-2 text-xs text-gray-500 uppercase">Search & Choose</div>
						<ListHubContacts hubId={hubId} onContactSelect={onContactSelect} />
					</div>

					<div className="flex flex-col flex-1 p-4 bg-white rounded">
						{selectedContacts.length > 0 && (
							<>
								<label className="text-xs text-gray-500 uppercase">
									Selected Contacts
								</label>
								<div className="flex flex-row flex-wrap gap-2 mt-1 mb-3">
									{selectedContacts.map((cont) => {
										return (
											<div
												key={cont?.phone}
												className="flex flex-row p-1 px-3 text-xs bg-gray-200 rounded-full"
											>
												<span className="mr-2">
													{cont?.firstname} : {cont?.phone}
												</span>
												<TrashIcon
													className="w-4 h-4 text-gray-500 cursor-pointer"
													onClick={() => removeSelectedContact(cont)}
												/>
											</div>
										)
									})}
								</div>

								{toggle ? (
									<>
										<label className="mt-4 text-xs text-gray-500 uppercase">
											Choose WhatsApp template
										</label>
										<select
											className="w-full px-2 py-1 text-sm border border-solid border-blue"
											value={currentTemplate?.templateid}
											onChange={(e) => {
												setCurrentTemplate(
													wpTemplates.find(
														(t) => t.templateid === e.target.value
													) || {}
												)
											}}
										>
											<option>Select</option>
											{wpTemplates.map((template) => (
												<option
													key={template.templateid}
													value={template.templateid}
												>
													{template.name} - {template.templatename}
												</option>
											))}
										</select>

										{currentTemplate?.templateid && (
											<div className="flex flex-col my-4 mt-8">
												<label className="text-xs text-gray-500 uppercase">
													Template Text
												</label>
												<div className="mb-2">
													{currentTemplate.templatetext}
												</div>

												<p className="mt-4 text-xs text-gray-400">
													This message will sent via Sender Phone:{" "}
													<b>{currentTemplate.senderPhone}</b>
												</p>

												<div className="flex flex-row gap-6">
													<div className="flex-[3]">&nbsp;</div>
													<div className="flex-1">
														&nbsp;
														{loading ? (
															<Button className="text-black bg-red-100 pointer-events-none">
																Loading
															</Button>
														) : (
															<Button
																className="w-full"
																onClick={sendSms}
															>
																Send WhatsApp
															</Button>
														)}
													</div>
												</div>
											</div>
										)}
									</>
								) : (
									<>
										<label className="mt-4 text-xs text-gray-500 uppercase">
											Choose SMS template
										</label>
										<select
											className="w-full px-2 py-1 text-sm border border-solid border-blue"
											value={currentTemplate?._id}
											onChange={(e) => {
												setCurrentTemplate(
													smsTemplates.find(
														(t) => t._id === e.target.value
													) || {}
												)
											}}
										>
											<option>Select</option>
											{smsTemplates.map((template) => (
												<option key={template._id} value={template._id}>
													{template.name}
												</option>
											))}
										</select>

										{currentTemplate?._id && (
											<div className="flex flex-col my-4 mt-8">
												<label className="text-xs text-gray-500 uppercase">
													Template Text
												</label>
												<div className="mb-2">{currentTemplate.text}</div>

												<p className="mt-4 text-xs text-gray-400">
													This message will sent via AccountId:{" "}
													<b>{currentTemplate.userId}</b> and SenderId:{" "}
													<b>{currentTemplate.senderId}</b>
													<br />
													having DTL TemplateId as :{" "}
													<b>{currentTemplate.dtlTemplateId}</b>{" "}
												</p>

												<div className="flex flex-row gap-6">
													<div className="flex-[3]">&nbsp;</div>
													<div className="flex-1">
														&nbsp;
														{loading ? (
															<Button className="text-black bg-red-100 pointer-events-none">
																Loading
															</Button>
														) : (
															<Button
																className="w-full"
																onClick={sendSms}
															>
																Send SMS
															</Button>
														)}
													</div>
												</div>
											</div>
										)}
									</>
								)}
							</>
						)}
					</div>
				</div>
			</div>
		</>
	)
}
